import { LAMINATE_REGEX } from '~/core/constants/materialType';

/**
 * Rules for filtering edges by material type and color colorBrand
 * @interface material match to the material.description
 * @interface colorBrand match to the color.colorBrand
 * @interface excludeBrand excludeBrand edges that match to edge.colorBrand
 */
export interface EdgeBrandFilterRule {
  material: RegExp | string;
  colorBrand: RegExp | string;
  excludeBrand: RegExp | string;
}

export const EDGE_BRAND_RULES: EdgeBrandFilterRule[] = [
  {
    material: LAMINATE_REGEX,
    colorBrand: /Formica/i,
    excludeBrand: /Wilsonart/i,
  }, //formica colors excludeBrand wilsonart edges
  {
    material: LAMINATE_REGEX,
    colorBrand: /Wilsonart/i,
    excludeBrand: /Formica/i,
  }, //wilsonart colors excludeBrand formica edges
];
